import { useEffect } from "react";
import { Link } from "react-scroll";
import { motion } from "framer-motion";

function Navbar({ playAnimation }) {
  useEffect(() => {
    const handleScroll = () => {
      const nav = document.querySelector(".navbar");
      const gotop = document.querySelector(".gotop");
      
      // Use innerWidth for viewport width
      const isMobile = window.innerWidth < 768;
      // Mobile header is 70vh, so trigger slightly before (0.65) or at that point.
      const mobileThreshold = window.innerHeight * 0.65;
      const scrollThreshold = isMobile ? mobileThreshold : 220;

      if (window.scrollY > scrollThreshold) {
        if (gotop) gotop.classList.add("display");
        if (nav) nav.classList.add("navopened");
      } else {
        if (gotop) gotop.classList.remove("display");
        if (nav) nav.classList.remove("navopened");
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Initial check
    handleScroll();

    // Cleanup listener on unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  function openBar() {
    const bar = document.querySelector(".bar");
    if (bar) {
      bar.classList.toggle("opened");
    }
  }

  return (
    <motion.nav 
      className="navbar"
      initial={{ y: -100, opacity: 0 }}
      animate={playAnimation ? { y: 0, opacity: 1 } : { y: -100, opacity: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      <div className="container">
        <div className="row">
          <h1 className="logo">
            <Link
              spy={true}
              smooth={true}
              duration={1000}
              to="headerbg"
              style={{ cursor: "pointer" }}
            >
              <img src={process.env.PUBLIC_URL + "/img/tss_biru.png"} alt="TSS Logo" style={{ height: '60px' }} />
            </Link>
          </h1>
          <ul className="bar">
            <li>
              <Link
                onClick={openBar}
                activeClass="active"
                spy={true}
                smooth={true}
                duration={1000}
                offset={-100}
                to="headerbg"
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                onClick={openBar}
                activeClass="active"
                to="services"
                spy={true}
                smooth={true}
                duration={1000}
                offset={0}
              >
                Services
              </Link>
            </li>
            <li>
              <Link
                onClick={openBar}
                to="about-scroll"
                spy={true}
                smooth={true}
                duration={1000}
                offset={-100}
                activeClass="active"
              >
                About
              </Link>
            </li>
            <li>
              <Link
                onClick={openBar}
                to="experience"
                spy={true}
                smooth={true}
                duration={1000}
                offset={-50}
                activeClass="active"
              >
                Experience
              </Link>
            </li>
            <li>
              <Link
                onClick={openBar}
                to="contact"
                spy={true}
                smooth={true}
                duration={1000}
                offset={-92}
                activeClass="active"
              >
                Contact
              </Link>
            </li>
          </ul>
          <div className="button" onClick={openBar}>
            <div className="burger"></div>
            <div className="burger"></div>
            <div className="burger"></div>
          </div>
        </div>
      </div>
    </motion.nav>
  );
}
export default Navbar;